import {
  createNewCommentService,
  createNewReplyService,
  deletePostCommentService,
  getCommentsService,
  updateCommentService,
  updateReplyService,
} from "../../../services/timeline";
import store from "../../index";
import {
  DELETE_COMMENT,
  DELETE_REPLY,
  INSERT_COMMENT,
  INSERT_REPLY,
  LOAD_COMMENTS,
  LOAD_COMMENTS_ERROR,
  LOAD_COMMENTS_LOADING,
  UPDATE_COMMENT,
  UPDATE_REPLY,
} from "../types";

export const getSingleVideoAction =
  ({ page, limit, postId, next }) =>
  (dispatch) => {
    if (next) {
      let { thisPage, allPages, loading } = store?.getState()?.video;
      if (loading) return;
      if (thisPage === allPages) return;
      page = thisPage + 1;
    }

    dispatch({ type: LOAD_COMMENTS_LOADING });

    return getCommentsService({
      page,
      limit,
      postId,
    })
      .catch((e) =>
        dispatch({
          type: LOAD_COMMENTS_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        if (d.error) {
          return dispatch({
            type: LOAD_COMMENTS_ERROR,
            payload: d.error,
          });
        }

        let byId = {};
        let allIds = [];
        d.data.comments.map((comment) => {
          byId[comment?.id] = comment;
          return allIds.push(comment.id);
        });
        d.byId = byId;
        d.allIds = allIds;
        d.post = d.data.post;
        delete d.data;
        dispatch({
          type: LOAD_COMMENTS,
          payload: d,
        });
      });
  };

export const createNewCommentAction =
  ({ files, text, cb, postId }) =>
  (dispatch) => {
    return createNewCommentService({ files, text, postId }).then((res) => {
      const { error, data } = res;
      if (error) return cb(error);
      cb(null, data);
      return dispatch({ type: INSERT_COMMENT, payload: data });
    });
  };

export const deleteCommentAction = (commentId) => (dispatch) => {
  dispatch({ type: DELETE_COMMENT, payload: commentId });
  deletePostCommentService({ ids: [commentId] });
};

export const deleteReplyAction =
  ({ replyId, commentId }) =>
  (dispatch) => {
    dispatch({ type: DELETE_REPLY, payload: { replyId, commentId } });
    // deletePostCommentService({ ids: [replyId] });
  };

export const createNewReplyAction =
  ({ files, text, cb, commentId }) =>
  (dispatch) => {
    return createNewReplyService({ files, text, commentId }).then((res) => {
      const { error, data } = res;
      if (error) return cb(error);
      cb(null);
      return dispatch({
        type: INSERT_REPLY,
        payload: { ...data, commentId },
      });
    });
  };

export const updateCommentAction =
  ({ data, cb }) =>
  (dispatch) => {
    return updateCommentService({ data }).then((res) => {
      const { error, data } = res;
      if (error) {
        return cb && cb(error);
      }

      dispatch({ type: UPDATE_COMMENT, payload: data });
      cb && cb();
    });
  };

export const updateReplyAction =
  ({ data, cb }) =>
  (dispatch) => {
    return updateReplyService({ data }).then((res) => {
      const { error, data } = res;
      if (error) {
        return cb && cb(error);
      }

      dispatch({ type: UPDATE_REPLY, payload: data });
      cb && cb();
    });
  };
